import Dialog from '@mui/material/Dialog';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Iconify from '../../../components/iconify';
import ByzMuiTypography from '../../../components/core-components/mui/inputs/ByzMuiTypography';
import ByzMuiButton from '../../../components/core-components/mui/buttons/ByzMuiButton';
import { useTranslate } from 'src/locales';

type Props = {
    open: boolean;
    onClose: VoidFunction;
};

export default function AccountAboutDialog({ open, onClose }: Props) {
    const { t } = useTranslate();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 2,
                    p: 1
                }
            }}
        >
            <Box sx={{ position: 'relative', p: 3, pt: 6, textAlign: 'center' }}>
                <ByzMuiButton
                    onClick={onClose}
                    variant2="contained"
                    color="error"
                    icon={<Iconify icon="eva:close-fill" sx={{ mr: 1 }} />}
                    sx={{
                        position: 'absolute',
                        top: 16,
                        right: 16,
                        bgcolor: '#b71c1c',
                        '&:hover': { bgcolor: '#801313' }
                    }}
                >
                    {t('close').toUpperCase()}
                </ByzMuiButton>

                <Stack spacing={1} sx={{ mt: 2 }} alignItems="center">
                    <ByzMuiTypography variant="h6" sx={{ fontWeight: 'bold' }}>
                        {`${t('version')} : ${process.env.REACT_APP_VERSION}`}
                    </ByzMuiTypography>
                    <ByzMuiTypography variant="body2" color="text.secondary">
                        www.bizmed.com.tr
                    </ByzMuiTypography>
                    <ByzMuiTypography variant="caption" color="text.disabled">
                        Copyright 2004 - 2026 Sinerji Bilgi Teknolojileri
                    </ByzMuiTypography>
                </Stack>
            </Box>
        </Dialog>
    );
}
